import Vue from 'vue';
import RobotChat, { RobotChatConfig } from 'robot-chat';
import i18n from 'common-module/src/lang';
import { sendRobotChatRecommend, sendRobotChatText, clearRobotChatRecommend } from '@/api/chatbot';
import store from '@/store';

Vue.use<RobotChatConfig>(RobotChat, {
  i18n,
  i18nResolver: (key: string, ...args: any[]) => Reflect.apply(i18n.t, i18n, [key, ...args]),
  i18nPluralizationResolver: (key: string, num: number, ...args: any[]) => Reflect.apply(i18n.tc, i18n, [key, num, ...args]),
  userInfo: () => {
    const { userId, head, userName, features } = (store.state as any).user.account;
    return {
      userId,
      avatar: head,
      userName,
      dataQueriesSwitch: features.webim_data_queries_switch
    };
  },
  sendMessage: async (type, message, params) => {
    const { userId, head } = (store.state as any).user.account;
    if (type === 'input' || type === 'sendInput') {
      const result = await sendRobotChatText({
        text: message,
        ...(params || {})
      });
      return {
        id: result.id || Date.now(),
        userId,
        avatar: head,
        type: 'ai.sendText',
        inputType: type,
        content: message
      };
    }
    if (type === 'confirm') {
      return sendRobotChatRecommend({
        ...message as Object,
        intent: params?.intent
      });
    }
    if (type === 'clear') {
      await clearRobotChatRecommend();
    }
  }
});
